import { requiredRule, ValidateOptions } from '@.hooks';
import { LICENSE_KEY_LENGTH } from '@/entities/Device/model';

import { EditLicenseKeySocketFormState } from './EditLicenseKeySocketFormState';

export const EditLicenseKeySocketValidateOptions: ValidateOptions<EditLicenseKeySocketFormState> = {
    licenseKey: {
        type: 'string',
        required: requiredRule,
        min: {
            value: LICENSE_KEY_LENGTH - 1,
            message: `License key length must be ${LICENSE_KEY_LENGTH}`,
        },
        max: {
            value: LICENSE_KEY_LENGTH + 1,
            message: `License key length must be ${LICENSE_KEY_LENGTH}`,
        },
    },
};
